<template>
    <div>
        <el-form :rules="rules" ref="ruleForm" :model="editData" label-width="100px">
            <el-form-item prop="name" class="lable-width" label="服务名称">
                <el-input class="input-width"  clearable v-model="editData.name"></el-input>
            </el-form-item>
            <el-form-item prop="destination" class="lable-width" label="目的地">
                <el-input class="input-width"  clearable v-model="editData.destination"></el-input>
            </el-form-item>
            <el-form-item prop="type" class="danxuan" label="消费类型">
<!--                <el-input  class="input-width" clearable v-model="editData.type"></el-input>-->
                <el-radio style="margin-left: 34px" v-model="editData.type" label="0">私有</el-radio>
                <el-radio v-model="editData.type" label="1">公共</el-radio>
            </el-form-item>
<!--            <el-form-item  class="lable-width" label="消费服务名称">-->
<!--                <el-select class="input-width" v-model="bianeditDataData.consumerServerName" placeholder="请选择消费服务名称">-->
<!--                    <el-option v-for="val in editData.xfname" :key="val.id" :label="val.name" :value="val.id"></el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item class="lable-width" label="录入人">
                <el-input class="input-width" disabled clearable v-model="editData.lruname"></el-input>
            </el-form-item>
            <el-form-item class="lable-width" label="创建时间">
                <el-input class="input-width" disabled clearable v-model="editData.createTime"></el-input>
            </el-form-item>
<!--            <el-form-item  label="是否启用">-->
<!--                <div style="margin-left: 46px">-->
<!--                    <el-radio v-model="editData.state" :label="1">是</el-radio>-->
<!--                    <el-radio v-model="editData.state" :label="0">否</el-radio>-->
<!--                </div>-->
<!--            </el-form-item>-->
            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'consumerEntry',
        props:{

            editData:{
                type:Object
            }
        },
        data(){
            return{
                rules: {
                    name: [
                        { required: true, message: '请输入名字', trigger: 'blur' },

                    ],
                    destination: [
                        { required: true, message: '请输入目的地', trigger: 'blur' }
                    ],
                    type: [
                        {  required: true, message: '请输入消费类型 ', trigger: 'blur' }
                    ],
                }
            }
        },
        watch:{
        },
        mounted(){

        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            //消费服务详情保存
            async saveConsumerServerInfo() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    name:this.editData.name,
                    destination:this.editData.destination,
                    type:this.editData.type,
                }
                let res = await API.saveConsumerServerInfo(params);
                if (res.code == 1) {
                    this.$emit('getConsumerServerInfoList')
                    this.$emit('close')
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });

                } else if (res.code == -2) {
                    this.$router.push('/login');

                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            close(){
                this.$emit('close')
            },

            onSubmit(){
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        // console.log(this.editData)
                        this.saveConsumerServerInfo()

                    } else {

                        return false;
                    }
                });
            },


        }
    }
</script>
<style lang="scss" scoped>
    /*.danxuan{*/
    /*    margin-left: 20px;*/
    /*}*/
    /deep/{
        .el-form-item__error{
            left: 50% !important;
        }
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 140px !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
</style>